import { JSX } from 'react';
import ImageUploadButtonField from './ImageUploadButtonField';
import ImageUploadDefaultField from './ImageUploadDefaultField';
import { ImageUploadFieldVariant } from './ImageUploadField';

const ImageUploadFieldType = ({
  variant,
  label = '',
  justifyContent = 'space-between',
  hasWhiteFields = false,
  isUploadDisabled = false,
  hasUploadFile = false,
  onClick,
  renderFieldContent,
}: {
  variant: ImageUploadFieldVariant;
  label?: string;
  justifyContent?: string;
  hasWhiteFields?: boolean;
  isUploadDisabled?: boolean;
  hasUploadFile?: boolean;
  onClick: () => void;
  renderFieldContent: (justifyContent?: string) => JSX.Element;
}) => {
  switch (variant) {
    case ImageUploadFieldVariant.Button:
      return (
        <ImageUploadButtonField
          label={label}
          justifyContent={justifyContent}
          hasWhiteFields={hasWhiteFields}
          hasUploadFile={hasUploadFile}
          isUploadDisabled={isUploadDisabled}
          onClick={onClick}
          renderFieldContent={renderFieldContent}
        />
      );
    default:
      return (
        <ImageUploadDefaultField
          label={label}
          justifyContent={justifyContent}
          hasUploadFile={hasUploadFile}
          onClick={onClick}
          renderFieldContent={renderFieldContent}
        />
      );
  }
};

export default ImageUploadFieldType;
